export default "__VITE_ASSET__BYe_5fud__"